import React from 'react'
import styled from 'react-emotion'
import { SaveIcon, EditIcon as PencilIcon, color, Input } from 'stylist'
import { updateSurveyMeta } from 'actions'
import { connect } from 'react-redux'

const _EditSaveIcon = props => {
  if (props.editable) {
    return (
      <SaveIcon className={props.className} size="m" onClick={props.onClick} />
    )
  } else {
    return (
      <PencilIcon
        className={props.className}
        size="m"
        onClick={props.onClick}
      />
    )
  }
}

const EditSaveIcon = styled(_EditSaveIcon)`
  display: block;
  float: left;
  height: 37px;
  width: 37px;
  margin-left: 10px;
  margin-top: -10px;
  padding: ${props => (props.editable ? '8px' : '10px')};
  cursor: pointer;
  color: ${props => color(props.editable ? 'slate' : 'white')};
  background-color: ${props =>
    color(props.editable ? 'lightBrandGreen' : 'initial')};
  border-radius: 3px;
`

const TitleInput = styled(Input)`
  display: inline-block;
  float: left;
  width: 220px;
  margin-top: -10px;
  border-color: ${color('cadet')};
`

const TitleSpan = styled.span`
  display: inline-block;
  float: left;
  max-width: 220px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

class EditableTitle extends React.Component {
  constructor(props) {
    super(props)

    this.input = React.createRef()
  }

  onChange = ev => {
    this.props.updateTitle(ev)
  }

  onKeyDown = ev => {
    if (ev.key === 'Enter') {
      this.props.done()
    }
  }

  render() {
    const { title, editable } = this.props

    if (editable) {
      return (
        <TitleInput
          type="text"
          size="sm"
          value={title}
          onChange={this.props.updateTitle}
          onKeyDown={this.onKeyDown}
          onBlur={this.props.done}
          autoFocus={true}
        />
      )
    } else {
      return <TitleSpan title={this.props.title}>{this.props.title}</TitleSpan>
    }
  }
}

const ContentTitleContainer = styled.p`
  display: inline-block;
  width: 400px;
  margin-top: 12px;
  font-size: 16px;
  font-weight: bold;
  color: ${color('paleGrey')};
`

class Title extends React.Component {
  state = { editable: false }

  updateTitle = ev => {
    const state = this.state

    state.title = ev.target.value

    this.setState(state)
  }

  toggleEditable = ev => {
    if (!this.state.editable) {
      this.setState({
        title: this.props.title,
        editable: true
      })
    } else {
      this.setState(
        {
          editable: false
        },
        () => {
          this.props.updateSurveyMeta({
            title: this.state.title
          })
        }
      )
    }
  }

  render() {
    const { title: ourTitle, editable } = this.state
    const { title } = this.props

    return (
      <ContentTitleContainer>
        <EditableTitle
          title={editable ? ourTitle : title}
          updateTitle={this.updateTitle}
          editable={editable}
          done={this.toggleEditable}
        />
        <EditSaveIcon editable={editable} onClick={this.toggleEditable} />
      </ContentTitleContainer>
    )
  }
}

const mapStateToProps = state => {
  return state.surveyMeta
}

const mapDispatchToProps = dispatch => {
  return {
    updateSurveyMeta: payload => {
      dispatch(updateSurveyMeta(payload))
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Title)



// WEBPACK FOOTER //
// ./src/components/Editor/Header/Title.js